import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const fetchReviews = createAsyncThunk("reviews/fetchAll", async () => {
    return await ApiService.get("/reviews",false);
  });
  
  export const fetchReviewById = createAsyncThunk("reviews/fetchById", async (id) => {
    return await ApiService.getById("/review", id);
  });
  
  export const createReview = createAsyncThunk("reviews/create", async (newReview) => {
    return await ApiService.post("/createreviews", newReview,true);
  });
  
  export const updateReview = createAsyncThunk("reviews/update", async ({ id, updatedReview }) => {
    return await ApiService.put("/reviews", id, updatedReview,true);
  });
  
  export const deleteReview = createAsyncThunk("reviews/delete", async (id) => {
    await ApiService.delete("/reviews", id,true);
    return id;
  });
  